import React from 'react';

const ChatMessage = ({ message, isUser = false }) => {
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"} animate-fade-in`}>
      <div className={`flex items-start space-x-3 max-w-[80%] ${
        isUser ? "flex-row-reverse space-x-reverse" : ""
      }`}>
        {!isUser && (
          <div className="w-8 h-8 bg-gradient-to-br from-[#831f82] to-[#2e0059] rounded-full flex items-center justify-center text-white text-sm flex-shrink-0 mt-1">
            🤖
          </div>
        )}
        <div
          className={`p-4 rounded-2xl shadow-sm ${
            isUser
              ? "bg-gradient-to-br from-[#831f82] to-[#2e0059] text-white rounded-br-md"
              : "bg-white border border-gray-200 text-gray-900 rounded-bl-md"
          }`}
        >
          <div className="whitespace-pre-wrap break-words">
            {message.content}
          </div>
          <p className={`text-xs mt-2 opacity-70 ${
            isUser ? "text-purple-100" : "text-gray-500"
          }`}>
            {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
